'use client';

import { c as _c } from "react/compiler-runtime";
import type { WebMainPageResponse } from '@module/apis/client-side/main/type';
import getMainListAdjustSize from '@pc/utils/main/getMainListAdjustSize';
import MainBroadcastSection, { type MainSectionProps } from './MainBroadcastSection';
interface Props extends MainSectionProps {
  data?: WebMainPageResponse;
}
function NewBjContainer(t0) {
  const $ = _c(10);
  const {
    data,
    isLoading,
    isFetching,
    isFetched,
    currentScreenSize,
    listLength
  } = t0;
  let t1;
  if ($[0] !== currentScreenSize || $[1] !== data || $[2] !== listLength) {
    t1 = data?.newBjList ? getMainListAdjustSize({
      list: data.newBjList,
      currentScreenSize,
      listLength
    }) ?? [] : undefined;
    $[0] = currentScreenSize;
    $[1] = data;
    $[2] = listLength;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const bjList = t1;
  let t2;
  if ($[4] !== bjList || $[5] !== isFetched || $[6] !== isFetching || $[7] !== isLoading || $[8] !== listLength) {
    t2 = <MainBroadcastSection dataTestId="main-newbj" title={"NEW BJ\uBC29\uC1A1"} list={bjList} isLoading={isLoading} isFetching={isFetching} isFetched={isFetched} listLength={listLength} />;
    $[4] = bjList;
    $[5] = isFetched;
    $[6] = isFetching;
    $[7] = isLoading;
    $[8] = listLength;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
export default NewBjContainer;